/**
 * Searches products for a valid and active trial.
 *
 * activeDate: (Optional) Filter by a date. Exclude products with an end date after the activeDate
 */
define('lib/models/account/find-expiring-trial',['require','lodash','moment'],function (require) {
    var _ = require('lodash');
    var moment = require('moment');

    return function (products, activeDate) {
        return _.find(products, function (product) {
            var check = product.product === 'GoToMeeting' &&
                product.active &&
                product.trial &&
                !product.autoRenew;

            if (activeDate) {
                check = check && moment(product.endDate).diff(activeDate) < 0;
            }

            return check;
        });
    };
});

